'use strict';

/**
 Коды ошибок из системы i-retail
 */

/** Ошибка аутентификации пользователя по grant_type=password*/

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ERROR_CODE_AUTHENTICATION = exports.ERROR_CODE_AUTHENTICATION = 300;
/** Ошибка запроса время жизни access token истекло*/
var ERROR_CODE_INVALID_ACCESS_TOKEN = exports.ERROR_CODE_INVALID_ACCESS_TOKEN = 301;
/** Ошибка аутентификации пользователя по refresh_token*/
var ERROR_CODE_INVALID_REFRESH_TOKEN = exports.ERROR_CODE_INVALID_REFRESH_TOKEN = 302;
/** Следующий запрос надо отправлять с подтверждением капчи */
var ERROR_CODE_NEED_SEND_CAPTCHA = exports.ERROR_CODE_NEED_SEND_CAPTCHA = 303;
/** Нет капчи или неверно введена */
var ERROR_CODE_INVALID_CAPTCHA = exports.ERROR_CODE_INVALID_CAPTCHA = 304;
/** Пользователь временно заблокирован по ip */
var ERROR_CODE_USER_IP_BLOCKED = exports.ERROR_CODE_USER_IP_BLOCKED = 305;
/** Пользователь заблокирован в системе i-Retail */
var ERROR_CODE_USER_BLOCKED = exports.ERROR_CODE_USER_BLOCKED = 306;
/** По преданному токену интернет-магазин для авторизации не найден */
var ERROR_CODE_NOT_FOUND_CLOUD_FISCAL = exports.ERROR_CODE_NOT_FOUND_CLOUD_FISCAL = 307;
/** Ошибка авторизации по логину и api_key */
var ERROR_CODE_AUTH_BY_API_KEY_AND_LOGIN = exports.ERROR_CODE_AUTH_BY_API_KEY_AND_LOGIN = 308;
/** Группа ошибок связанных с тарифами */
var ERROR_CODE_TARIFF = exports.ERROR_CODE_TARIFF = 158;
/** Неизвестная ошибка - для всех эксепшнов, не описанных в коде специально */
var ERROR_CODE_GENERAL_ERROR = exports.ERROR_CODE_GENERAL_ERROR = 400;
/** Неизвестная ошибка */
var ERROR_UNKNOWN_ERROR = exports.ERROR_UNKNOWN_ERROR = 0;
/** Недостаточно товара на складе */
var ERROR_FEW_PRODUCTS = exports.ERROR_FEW_PRODUCTS = 160;

var ERROR_SLUG_TARIFF = exports.ERROR_SLUG_TARIFF = 'error.issetLatePaymentTariff';

var ERROR_SLUG_INVALID_ACCESS_TOKEN = exports.ERROR_SLUG_INVALID_ACCESS_TOKEN = 'user.invalid_access_token';

var ERROR_SLUG_GENERAL_ERROR = exports.ERROR_SLUG_GENERAL_ERROR = 'common.errorGeneral';

// Соединение прервано неожиданно
var ERROR_CODE_CONNECTION_CLOSE_UBNORMAL = exports.ERROR_CODE_CONNECTION_CLOSE_UBNORMAL = -10;

// Статус, для непонятных и глупых ошибок, которые не нужно особо обрабатывать
var ERROR_STATUS_FOR_INTERNAL_CASE = exports.ERROR_STATUS_FOR_INTERNAL_CASE = 418;


//////////////////
// WEBPACK FOOTER
// ./src/api/errors.constants.js
// module id = 744
// module chunks = 0